// The categories of the Settings page: `/settings` lists them, `/settings/<key>` shows one.
export interface SettingsSection {
  key: string
  icon: string
  titleKey: string // (i18n key of the entry's title)
  adminOnly?: boolean
}

export const SETTINGS_SECTIONS: readonly SettingsSection[] = [
  { key: 'language', icon: '🌐', titleKey: 'settings.language.title' },
  { key: 'customisation', icon: '🎨', titleKey: 'settings.customisation.title' },
  { key: 'accounts', icon: '📆', titleKey: 'accounts.title' },
  { key: 'invites', icon: '✉️', titleKey: 'settings.invites.title' },
  { key: 'notifications', icon: '🔔', titleKey: 'settings.notifications.title' },
  { key: 'tags', icon: '🏷️', titleKey: 'settings.tags.title' },
  { key: 'blocked', icon: '🚫', titleKey: 'settings.blocked.title' },
  { key: 'export', icon: '📤', titleKey: 'settings.export.title' },
  { key: 'tokens', icon: '🔑', titleKey: 'settings.tokens.title', adminOnly: true },
  { key: 'debug', icon: '🛠️', titleKey: 'settings.debug.title' }, // (read-only troubleshooting views, so at the end)
]

// The sections this user sees, in the order of the list.
export function sectionsFor(isAdmin: boolean): SettingsSection[] {
  return SETTINGS_SECTIONS.filter((section) => isAdmin || !section.adminOnly)
}

// The section a route parameter names, or none if it is unknown or not for this user.
export function findSection(key: unknown, isAdmin: boolean): SettingsSection | undefined {
  return typeof key === 'string'
    ? sectionsFor(isAdmin).find((section) => section.key === key)
    : undefined
}
